import { get, isEmpty } from 'lodash';
import { requestUtils } from 'helpers/saga-helpers';
import userToken from 'containers/services/security/access-token-storage';
import { getLiveDocumentViewUrlIntervenant } from 'services/api-path';

export const openDocument = (url: string) => () => window.open(url);
export const getLiveDocumentViewUrl = (
  path: string,
  filename: string,
  isIndexed: boolean,
  documentId: string,
) => {
  const baseApiPath = requestUtils.getApiBasePath();
  const accessToken = get(userToken.get(), 'token');
  if (accessToken) {
    if (isIndexed) {
      return `${baseApiPath}/corporeal/view-document?isIndexed=${isIndexed}&documentId=${documentId}&sagisToken=${accessToken}`;
    } else {
      return `${baseApiPath}/corporeal/view-document?filePath=${path}&fileName=${filename}&sagisToken=${accessToken}`;
    }
  } else {
    return getLiveDocumentViewUrlIntervenant(documentId);
  }
};
export const formatDocument = (claim: any) => {
  if (
    !isEmpty(get(claim, 'sagis.claims[0].ListDocsNotIndexed', [])) ||
    !isEmpty(get(claim, 'sagis.claims[0].ListDocsIndexed', []))
  ) {
    return [
      ...get(claim, 'sagis.claims[0].ListDocsNotIndexed', []).map(
        (document: {
          type: string;
          name: string;
          fileName: string;
          path: string;
        }) => ({
          isIndexed: false,
          ...document,
        }),
      ),
      ...get(claim, 'sagis.claims[0].ListDocsIndexed', []).map(
        (document: {
          DocumentID: string;
          DocumentType: string;
          fileName: string;
          path: string;
        }) => ({
          isIndexed: true,
          documentId: document.DocumentID,
          type: document.DocumentType,
          fileName: document.fileName,
          path: document.path,
        }),
      ),
    ];
  } else {
    return [];
  }
};
